import {
  TableHeader,
  TableHeaderCell,
  TableHeadRow,
  TableHeaderCellContent,
  TableHeaderDropdownIcon,
  ColumnDropDownWrapper,
  ColumnDropdownBackdropContainer,
  ColumnDropDownItem,
  ColumnDropDownGroupHeader,
  DisplayName,
  SortDownIcon,
  SortUpIcon,
  EmptySortIcon,
  FiltersWrapper,
} from './TableHead.styled';
import { MenuList, MenuGroup, Checkbox } from '@fluentui/react-components';
import {
  ArrowSortDownRegular,
  ArrowSortUpRegular,
} from '@fluentui/react-icons';
import {
  FilterOptions,
  SingleTicketTransformed,
} from 'src/components/Tickets/models/Tickets.interface';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';
import { tableHeaderDisplayName } from 'src/components/Tickets/MyTickets.constants';

const DEFAULT_ASC = 'Ascending';
const DEFAULT_DESC = 'Descending';

const sortTextLookUp: {
  [key in keyof typeof tableHeaderDisplayName]: { asc: string; desc: string };
} = {
  createdon: { asc: 'Earliest first', desc: 'Latest first' },
  new_id: { asc: 'Ascending', desc: 'Descending' },
  new_description: { asc: 'Ascending', desc: 'Descending' },
  new_tickettype: { asc: 'Ascending', desc: 'Descending' },
  _new_category_value: { asc: 'Ascending', desc: 'Descending' },
  new_priority: { asc: 'Ascending', desc: 'Descending' },
  new_approvalstatus: { asc: 'Ascending', desc: 'Descending' },
  owner: { asc: 'Ascending', desc: 'Descending' },
  statuscode: { asc: 'Ascending', desc: 'Descending' },
};

export const TableHead = () => {
  const {
    tableHeaderDisplayNameLookUp,
    openedCurrentDropdownColumnId,
    sortedColumnId,
    sortedOrder,
    filterOptions,
    filterTicketsBySingleOption,
    toggleDesktopTableDropdown,
    sortTickets,
  } = useServiceDeskContext();
  return (
    <TableHeader>
      <TableHeadRow>
        {Object.entries(tableHeaderDisplayNameLookUp)?.map(
          ([columnId, displayName], i) => {
            const isLastColumn =
              i === Object.keys(tableHeaderDisplayNameLookUp).length - 1;
            const isDropDownOpen = openedCurrentDropdownColumnId === columnId;
            const isSorted = sortedColumnId === columnId;

            const columnFilters =
              filterOptions[columnId as keyof FilterOptions];

            return (
              <TableHeaderCell key={columnId}>
                <TableHeaderCellContent>
                  <DisplayName className={isSorted && 'activeSorting'}>
                    {displayName}
                  </DisplayName>
                  {isSorted ? (
                    sortedOrder === 'asc' ? (
                      <SortUpIcon />
                    ) : (
                      <SortDownIcon />
                    )
                  ) : (
                    <EmptySortIcon />
                  )}
                  <TableHeaderDropdownIcon
                    onClick={() =>
                      toggleDesktopTableDropdown(
                        columnId as keyof FilterOptions,
                        true
                      )
                    }
                  />
                  {isDropDownOpen && (
                    <>
                      <ColumnDropdownBackdropContainer
                        onClick={() => toggleDesktopTableDropdown()}
                      ></ColumnDropdownBackdropContainer>
                      <ColumnDropDownWrapper
                        className={`${isLastColumn && 'last'}`}
                      >
                        <MenuList>
                          <MenuGroup>
                            <ColumnDropDownGroupHeader>
                              Sort
                            </ColumnDropDownGroupHeader>
                            <ColumnDropDownItem
                              onClick={() => sortTickets('asc', columnId)}
                            >
                              <ArrowSortUpRegular />
                              {sortTextLookUp[columnId]?.asc || DEFAULT_ASC}
                            </ColumnDropDownItem>
                            <ColumnDropDownItem
                              onClick={() => sortTickets('desc', columnId)}
                            >
                              <ArrowSortDownRegular />
                              {sortTextLookUp[columnId]?.desc || DEFAULT_DESC}
                            </ColumnDropDownItem>
                          </MenuGroup>

                          <MenuGroup>
                            {columnFilters && (
                              <ColumnDropDownGroupHeader>
                                Filter
                              </ColumnDropDownGroupHeader>
                            )}
                            <FiltersWrapper>
                              {columnFilters &&
                                Object.values(columnFilters)?.map(
                                  ({ label, checked }) => (
                                    <ColumnDropDownItem key={label}>
                                      <Checkbox
                                        checked={checked}
                                        onChange={() =>
                                          filterTicketsBySingleOption(
                                            columnId as keyof SingleTicketTransformed,
                                            label
                                          )
                                        }
                                        label={label}
                                      />
                                    </ColumnDropDownItem>
                                  )
                                )}
                            </FiltersWrapper>
                          </MenuGroup>
                        </MenuList>
                      </ColumnDropDownWrapper>
                    </>
                  )}
                </TableHeaderCellContent>
              </TableHeaderCell>
            );
          }
        )}
        <TableHeaderCell></TableHeaderCell>
      </TableHeadRow>
    </TableHeader>
  );
};
